import { createApp } from 'vue'
import './styles/tailwind.css'
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import App from './App.vue'
import { setupRouter } from './router'
import { installUiWidgets } from './ui/widgets'
import { setupStore } from './store'
import { setupI18n } from './i18n'

async function bootstrap() {
  const app = createApp(App)

  // install pinia
  setupStore(app)

  setupI18n(app)
  installUiWidgets(app)

  setupRouter(app)
  app.mount('#app')
}

void bootstrap()
